export default "__VITE_ASSET__7q0WXNXb__"